import { render, staticRenderFns } from "./EscalaPontoEletronico.vue?vue&type=template&id=548450ed&"
import script from "./EscalaPontoEletronico.vue?vue&type=script&lang=js&"
export * from "./EscalaPontoEletronico.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EscalaPontoEletronico.vue?vue&type=style&index=1&id=548450ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports